module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"post":"Posted","total":"Total","edit_profile":"Edit profile","favorited_post":"Liked post","commented_post":"Commented post"}}')
  delete Component.options._Ctor
}
